import React from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';

import whatsappIcon from '../assets/whatsapp.png';
import { useV2Common } from '../state/CommonProvider';

const HIDE_ON_ROUTES = ['/v2/checkout/summary', '/v2/checkout/pay'];

export default function FloatingWhatsAppButton() {
  const { isDesktop } = useV2Common();
  const { pathname } = useLocation();

  if (isDesktop || HIDE_ON_ROUTES.includes(pathname)) return null;

  const openWhatsApp = () => {
    window.open('https://wa.me/917386661281', '_blank', 'noopener,noreferrer');
  };

  return (
    <Box
      component="button"
      type="button"
      aria-label="Chat on WhatsApp"
      onClick={openWhatsApp}
      sx={(theme) => ({
        all: 'unset',
        cursor: 'pointer',
        position: 'fixed',
        right: { xs: 10, sm: 14 },
        bottom: `calc(${theme.spacing(8)} + env(safe-area-inset-bottom, 0px) + 14px)`,
        width: 54,
        height: 54,
        borderRadius: '50%',
        bgcolor: '#ffefd1',
        zIndex: theme.zIndex.appBar - 1,
        boxShadow: '0 2px 8px rgba(0,0,0,0.22)',
        display: 'grid',
        placeItems: 'center',
      })}
    >
      <Box component="img" src={whatsappIcon} alt="" sx={{ width: 54, height: 54, borderRadius: '50%' }} />
    </Box>
  );
}
